export default __webpack_public_path__ + "static/media/close.4eb5f565.svg";